var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',_vm._b({nativeOn:{"mousedown":function($event){return _vm.onClick.apply(null, arguments)},"touchstart":function($event){return _vm.onClick.apply(null, arguments)}}},'router-link',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }